import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-p-line-arrow2",
  "use": "icon-p-line-arrow2-usage",
  "viewBox": "0 0 26 27",
  "content": "<symbol viewBox=\"0 0 26 27\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-p-line-arrow2\">\n<g id=\"icon-p-line-arrow2_Frame\">\n<path id=\"icon-p-line-arrow2_Vector\" d=\"M3.60208 4.17944L7.32603 15.3513L10.6369 12.0416L21.158 22.5628L21.5711 22.9759L22.3986 22.1485L11.4643 11.2142L14.7739 7.9034L3.60208 4.17944Z\" />\n<path id=\"icon-p-line-arrow2_Vector_2\" d=\"M11.4652 11.2151L10.6378 12.0425L21.5711 22.9758L22.3986 22.1484L11.4652 11.2151Z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol